module.exports = __webpack_public_path__ + "img/greyjwc.1c71142c.webp";